import { render, staticRenderFns } from "./sendGroupMessage.vue?vue&type=template&id=1f4de916"
import script from "./sendGroupMessage.vue?vue&type=script&lang=js"
export * from "./sendGroupMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports